import { toImageUrlFields } from './resolve'
import { createImageCacheKey, saveImageToCache } from './storage'
import type { PersistUploadCacheResult, UploadResponseLike } from './types'

export async function persistUploadedImageCache(
  file: Blob,
  response: UploadResponseLike
): Promise<PersistUploadCacheResult> {
  const localCacheKey = createImageCacheKey()
  const metadata = toImageUrlFields(response)

  try {
    await saveImageToCache(localCacheKey, file, metadata)
    const localPreviewUrl = URL.createObjectURL(file)
    return { localCacheKey, localPreviewUrl }
  } catch (error) {
    console.warn('[image-cache] Failed to persist uploaded image locally:', error)
    const localPreviewUrl = URL.createObjectURL(file)
    return { localCacheKey: '', localPreviewUrl }
  }
}
